module.exports = __webpack_public_path__ + "assets/5479b3b634e621dc62d16341b43cf532.png";